import React, { Component } from "react";

import EmployeeDetailItemContainer from "./components/EmployeeDetailItemContainer";
import EmploymentDetailItemTextBox from "./components/EmploymentDetailItemTextBox";
import TheInput from "./components/TheInput";
import { getApi } from "../../../../utils/apiHelper";
import { main_url } from "../../../../utils/CommonFunction";

export default class RegionField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      region: null,
    };
  }

  async componentDidMount() {
    if (this.props.branchId) this.getRegion();
  }

  async getRegion() {
    const data = await getApi(
      `${main_url}employee/getRegion/${this.props.branchId}`
    );
    if (data && data.length > 0 && data[0].region) {
      this.setState({
        region: data[0].region,
      });
    }
  }

  render() {
    const { region } = this.state;

    if (this.props.isView) {
      return <EmploymentDetailItemTextBox label="Region" value={region} />;
    }

    return (
      <EmployeeDetailItemContainer label="Region">
        <TheInput
          value={region}
          isDisabled={true}
          onChange={null}
          style={{ width: "100%", height: 40 }}
        />
      </EmployeeDetailItemContainer>
    );
  }
}
